<template>
  <a-modal
    :title="dialogTitle"
    :visible="visible"
    :mask-closable="false"
    :width="450"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk('form')"
  >
    <a-form-model
      ref="form"
      :model="form"
      label-align="right"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="validateRules"
    >
      <a-form-model-item
        label="产品线名称:"
        prop="productLineName"
      >
        <a-input
          v-model="form.productLineName"
          placeholder="请填写产品线名称"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item
        label="产品类型:"
        prop="productTypeIds"
      >
        <a-select
          v-model="form.productTypeIds"
          placeholder="请选择产品类型"
          mode="multiple"
          allow-clear
          show-search
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in productTypeOptionsNew"
            :key="item.productTypeId"
            :disabled="item.disabled"
          >
            {{ item.productTypeName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateProductLine, addProductLine, queryProductTypes } from '@/api/productLine.js'
import moment from 'moment'
import { deepClone, filterOption } from '@/utils/utils.js'
import {
  queryAllProductTypes
} from '@/api/common.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    initData: {
      type: Object,
      default: null
    },
    dialogTitle: {
      type: String,
      default: null
    },
    productTypetions: {
      type: Array,
      default: null
    },
    actionType: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      form: {
        productLineName: undefined,
        productTypeIds: []
      },
      validateRules: {
        productLineName: [{ required: true, message: '请输入产品线名称' }],
        productTypeIds: [{ required: true, message: '请选择产品类型' }]
      },
      productTypeOptions: [],
      allChoosedTypes: [],
      productTypeOptionsNew: []
    }
  },
  watch: {
    initData: {
      deep: true,
      handler: function (data) {
        this.form = this.deepClone(data)
        queryAllProductTypes().then((data) => {
          this.productTypeOptions = data
        })

        queryProductTypes().then((data) => {
          const allChoosedList = data || []
          allChoosedList.forEach(item => {
            this.allChoosedTypes.push(item.productTypeId)
          })

          // 对所有的选项遍历，不符合条件的禁用，options选项数据不是双向绑定的吗？？
          this.productTypeOptionsNew = this.deepClone(this.productTypeOptions)
          this.productTypeOptions.map((item, index) => {
            if (this.allChoosedTypes.includes(item.productTypeId) && !this.form.productTypeIds.includes(item.productTypeId)) {
              this.productTypeOptionsNew[index].disabled = true
            } else {
              this.productTypeOptionsNew[index].disabled = false
            }
          })
        })
      }
    }
  },
  methods: {
    moment,
    filterOption,
    deepClone,
    handleCancel () {
      this.$refs.form.resetFields()
      this.$emit('cancel')
    },
    handleOk () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.actionType === '0') {
            await updateProductLine(
              {
                ...this.form
              }
            ).then(() => {
              this.$message.success('提交成功!')
              this.$emit('ok')
            })
          } else {
            await addProductLine({
              ...this.form
            }
            ).then(() => {
              this.$message.success('提交成功!')
              this.$emit('ok')
            })
          }
        }
      })
    }
  }
}
</script>
